<template>
  <div id="visualizar-contrato" dusk="visualizar-contrato" class="readonly-container">
    <div class="vx-row">
      <vs-col vs-lg="8" vs-md="6" vs-sm="12">
        <vs-tabs>
          <vs-tab label="Informações" icon="people">
            <vx-card
              ref="dadosPessoaisCard"
              title="Dados pessoais"
              subtitle="Preencha corretamente os dados pessoais do cliente."
              cardBorder
              noShadow
            >
              <editar-dados-pessoais ref="dadosPessoaisRef" v-model="cliente"></editar-dados-pessoais>
            </vx-card>

            <vx-card
              ref="enderecosCard"
              title="Endereços"
              subtitle="Preencha corretamente o endereço do cliente."
              cardBorder
              noShadow
            >
              <div
                class="editar-endereco-container"
                v-for="(endereco, index) in enderecos"
                v-bind:key="endereco.id"
              >
                <editar-endereco ref="enderecosRef" v-model="enderecos[index]"></editar-endereco>
              </div>
            </vx-card>

            <vx-card
              ref="telefonesCard"
              title="Telefones"
              subtitle="Preencha corretamente o telefone do cliente."
              cardBorder
              noShadow
            >
              <div
                class="editar-telefone-container"
                v-for="(telefone, index) in telefones"
                v-bind:key="telefone.id"
              >
                <editar-telefone ref="telefonesRef" v-model="telefones[index]"></editar-telefone>
              </div>
            </vx-card>
          </vs-tab>

          <vs-tab label="Documentos" icon="attach_file">
            <vx-card
              title="Documentos"
              subtitle="Anexe corretamente os documentos do contrato."
              cardBorder
              noShadow
            >
              <editar-documentos :contrato="desconto" :pendencias="pendencias"></editar-documentos>
            </vx-card>
          </vs-tab>

          <vs-tab label="Anotações" icon="speaker_notes">
            <vx-card
              title="Anotações"
              subtitle="Quando necessário, você pode adicionar anotações do contrato."
              cardBorder
              noShadow
            >
              <editar-anotacoes></editar-anotacoes>
            </vx-card>
          </vs-tab>
        </vs-tabs>
      </vs-col>

      <vs-col vs-lg="4" vs-md="6" vs-sm="12" class="vx-col mb-4 padding-sidebar-contrato">
        <div class="vx-row">
          <!-- Situação do contrato -->
          <vs-col vs-w="12" class="vx-col mb-6">
            <vx-card
              ref="situacaoDescontoCard"
              title="Situação do contrato"
              cardBorder
              noShadow
              class="vx-card-green"
            >
              <editar-situacao-contrato ref="situacaoDescontoRef" v-model="situacao"></editar-situacao-contrato>
            </vx-card>
          </vs-col>
          <!-- Situação do contrato -->

          <!-- Cobrança -->
          <vs-col vs-w="12" class="vx-col mb-6">
            <vx-card ref="descontoCard" title="Cobrança" cardBorder noShadow class="vx-card-blue">
              <editar-cobranca-inss v-if="desconto.associacao" ref="cobrancaInssRef" v-model="desconto"></editar-cobranca-inss>
            </vx-card>
          </vs-col>
          <!-- Cobrança -->
        </div>
      </vs-col>
    </div>
  </div>
</template>

<script>
import EditarDadosPessoais from "./components/EditarDadosPessoais.vue";
import EditarEndereco from "./components/EditarEndereco.vue";
import EditarTelefone from "./components/EditarTelefone.vue";
import EditarDocumentos from "./components/EditarDocumentos.vue";
import EditarAnotacoes from "./components/EditarAnotacoes.vue";
import EditarSituacaoContrato from "./components/EditarSituacaoContrato.vue";
import EditarCobrancaInss from "./components/EditarCobrancaInss.vue";
import queryParams from "@services/repository-service";
import api from "@services/api-service";

export default {
  components: {
    EditarDadosPessoais,
    EditarEndereco,
    EditarTelefone,
    EditarDocumentos,
    EditarAnotacoes,
    EditarSituacaoContrato,
    EditarCobrancaInss
  },
  provide() {
    return {
      $validator: this.$validator
    };
  },
  data() {
    return {
      tabAtual: 0,
      pendencias: {},
      desconto: {
        beneficio: {}
      },
      cliente: {},
      enderecos: [{}],
      telefones: [{}],
      situacao: {},
      anexos: {},
      loading: false
    };
  },
  mounted() {
    this.loading = true;
    setTimeout(async () => {
      await this.buscarDesconto();
      await this.buscarPendencias();

      this.$socket
        .channel(`Contrato.${this.desconto.id}`)
        .listen(".PendenciasAtualizadas", this.buscarPendencias)
        .listen(".ContratoAtualizado", this.atualizarContratoSocket);

      this.loading = false;
    }, 100);
  },
  watch: {
    loading(loading) {
      if (!this.$refs.dadosPessoaisCard) return;

      const cards = [
        this.$refs.dadosPessoaisCard,
        this.$refs.enderecosCard,
        this.$refs.telefonesCard,
        this.$refs.descontoCard,
        this.$refs.situacaoDescontoCard
      ];

      if (loading) {
        cards.map(card => card.refreshcard());
      } else {
        cards.map(card => card.removeRefreshAnimation());
      }
    }
  },
  methods: { 
    async buscarDesconto() {
      try {
        const response = await api().get(`contratos/${this.$route.params.id}`, {
          params: queryParams({
            relationships: [
              "status",
              "statusMotivo",
              "cliente",
              "associacao",
              "entidade",
              "formaPagamento",
              "cliente.sexo",
              "cliente.estadoCivil",
              "cliente.enderecos",
              "cliente.enderecos.estado",
              "cliente.telefones",
              "beneficio.especieBeneficio",
              "porcentagemDesconto",
              "beneficio",
              "tipoContrato"
            ]
          })
        });

        if (response.data.status) {
          this.desconto = response.data.data;
          this.cliente = this.desconto.cliente;
          this.situacao = {
            id: this.desconto.id,
            status: this.desconto.status,
            statusMotivo: this.desconto.statusMotivo
          };
          this.anexos = {
            id: this.desconto.id,
            anexos: []
          };

          if (this.cliente.enderecos.length > 0) {
            this.enderecos = this.cliente.enderecos;
          }

          if (this.cliente.telefones.length > 0) {
            this.telefones = this.cliente.telefones;
          }
        }
      } catch (error) {
        //
      }
    },
    async buscarPendencias() {
      
      try {
        const response = await api().get(
          `/contratos/${this.desconto.id}/pendencias`
        );

        this.pendencias = response.data.data;
      } catch (error) {
        // ...
      }
    },
        atualizarContratoSocket({ data }) {
      this.desconto = this.$plugins.deepMerge(this.desconto, data);
    }
  }
};
</script>



